//------------------------------------------------------------------------------
//
// OAIDC Settings
//
// Defines configuration for interacting with our SSO system based on the
// current URL.
//
//------------------------------------------------------------------------------

let environment = '';

switch (window.location.origin) {
  case 'https://netox.apnic.net':
    environment = 'production';
    break;
  default:
    environment = 'other';
}

export const isNonProdEnv = environment === 'other';

export const OIDC_ROOT =
  environment === 'production'
    ? 'https://login.apnic.net'
    : 'https://beta-login.svc.tst.apnic.int';

export const client_id =
  environment === 'production'
    ? '0oa1psep8ouht9dLA3l7'
    : '0oa45llia79GfSGUL0x7';

const post_logout_redirect_uri =
  environment === 'production'
    ? 'https://profile.apnic.net/single-logout'
    : 'https://user-management.svc.tst.apnic.int/single-logout';

const authority = `${OIDC_ROOT}/oauth2/apnic`;

const response_type = 'code';

export default {
  authority: authority,
  client_id: client_id,
  redirect_uri: window.location.origin + '/auth-callback',
  response_type: response_type,
  scope: 'openid email profile offline_access',
  automaticSilentRenew: true,
  silent_redirect_uri: window.location.origin + '/silent-renew-oidc.html',
  post_logout_redirect_uri: post_logout_redirect_uri,
};

export const profileSectionURLs =
  environment === 'production'
    ? {
        personalSettingsURL: 'https://profile.apnic.net',
        passwordSecurityURL: 'https://profile.apnic.net/password-security',

        myApnicDashboardURL: 'https://my.apnic.net',
        linkExistingMembership:
          'https://resources.apnic.net/auth/nm-landing-page.html',
        membershipApplication: 'https://www.apnic.net/get-ip/apnic-membership',
      }
    : {
        personalSettingsURL: 'https://user-management.svc.tst.apnic.int',
        passwordSecurityURL:
          'https://user-management.svc.tst.apnic.int/password-security',
        myApnicDashboardURL: 'https://myapnic-portal.svc.tst.apnic.int',
        linkExistingMembership:
          'https://myapnic-facade.svc.tst.apnic.int/auth/nm-landing-page.html',
        membershipApplication:
          'https://membership-application.svc.tst.apnic.int',
      };
/*



*/
